jQuery(function ($) {
  const section       = $('[data-hero]');
  const modal         = section.find('[data-modal]');
  const modalTrigger  = section.find('[data-modal-trigger]');
  const modalClose    = modal.find('[data-modal-close]');
  const modalBackdrop = modal.find('[data-modal-backdrop]');
  const animation     = section.find('[data-animation]');

  // modal functionality
  let focusElement = false;

  function closeModal() {
    modal.removeClass('is-open');

    if (focusElement.length > 0) {
      focusElement.focus();
    }

    // remove src from iframe to stop playback
    const iframe = section.find('iframe[src], video[src]');
    iframe.attr('data-src', iframe.attr('src')).removeAttr('src');
  }

  modalTrigger.on('click', function () {
    focusElement = $(':focus');
    modal.addClass('is-open');

    // restore iframe src
    const iframe = section.find('iframe[data-src], video[data-src]');
    if (iframe) {
      iframe.attr('src', iframe.data('src'));
    }
  });

  modalClose.on('click', closeModal);
  modalBackdrop.on('click', closeModal);

  $(document).on('keyup', function (e) {
    if (e.keyCode === 27 && modal.hasClass('is-open')) {
      closeModal();
    }
  });
});
